import { Aspect } from '@teambit/harmony';

export const DependencyResolverAspect = Aspect.create({
  id: 'teambit.dependencies/dependency-resolver',
  dependencies: [],
  defaultConfig: {},
});
